import script from "./SharedNewTextfield.vue?vue&type=script&setup=true&lang=ts"
export * from "./SharedNewTextfield.vue?vue&type=script&setup=true&lang=ts"

import "./SharedNewTextfield.vue?vue&type=style&index=0&id=901af62a&lang=postcss"

const __exports__ = script;

export default __exports__